import React from "react"
import FormBuilder from "./FormBuilder"
import DynamicForm from "../DynamicForm";
import ToitureFormBuilder from "./Toiture/ToitureFormBuilder";
import Toiture from "./Toiture/Toiture";
import BeHead from "../../../Components/Head/BeHead";

const ManageToiture = () =>{

    const handleSave = (formConfig) => {
        console.log('Formulaire sauvegardé :', formConfig);
        // Tu peux ici l’enregistrer dans un fichier JSON, ou l’envoyer à ton API
    };

    return(
        <>
            <div>
                {/* <h3>Édition spécifique pour Toiture</h3>
                <p>Ici tu peux gérer les étapes pour Toiture.</p> */}
            </div>
            {/* <FormBuilder onSave={handleSave} /> */}
            {/* <FormBuilder />
            <DynamicForm /> */}
            <ToitureFormBuilder/>
            <Toiture/>
        </>
    )

}

export default ManageToiture